import React, { useState } from 'react';
import { KeyRound, Smartphone } from 'lucide-react';
import { useMozo } from './MozoSesion';
import { leerDispositivo } from './mozoApi';

export default function MozoLogin() {
  const { entrar, aviso } = useMozo();
  const [pin, setPin] = useState('');
  const [dispositivo, setDispositivo] = useState(leerDispositivo());
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const enviar = async (evento) => {
    evento.preventDefault();

    if (enviando) return;

    if (!pin.trim()) {
      setError('Ingresá tu PIN.');
      return;
    }

    setEnviando(true);
    setError('');

    const resultado = await entrar(pin.trim(), dispositivo.trim());

    if (!resultado.ok) {
      setError(resultado.error);
      setPin('');
    }

    setEnviando(false);
  };

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-gradient-to-b from-camp-900 via-camp-700 to-camp-500 px-5 py-8">
      {/* Carpas decorativas de fondo */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-16 bottom-0 h-0 w-0 border-b-[220px] border-l-[130px] border-r-[130px] border-b-white/10 border-l-transparent border-r-transparent"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-20 bottom-0 h-0 w-0 border-b-[300px] border-l-[170px] border-r-[170px] border-b-black/10 border-l-transparent border-r-transparent"
      />

      <div className="relative w-full max-w-sm">
        <form
          onSubmit={enviar}
          className="rounded-3xl bg-white p-6 shadow-2xl"
        >
          <img
            src="/brand/logo-camp-navbar.png"
            alt="Driza Camp"
            className="mx-auto h-28 w-full max-w-[16rem] object-contain"
          />

          <h1 className="mt-2 text-center text-2xl font-extrabold text-camp-800">
            Hola, mozo
          </h1>
          <p className="mt-1 text-center text-sm font-medium text-gray-600">
            Ingresá con tu PIN personal
          </p>

          {(aviso || error) && (
            <p
              role="alert"
              className="mt-4 rounded-xl bg-red-50 px-3 py-2 text-sm font-semibold text-red-700 ring-1 ring-red-200"
            >
              {error || aviso}
            </p>
          )}

          <label
            className="mt-5 flex items-center gap-2 text-sm font-bold text-camp-800"
            htmlFor="mozo-pin"
          >
            <KeyRound size={16} /> PIN
          </label>
          <input
            id="mozo-pin"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            autoFocus
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            className="mt-1 w-full rounded-2xl border-2 border-camp-200 bg-camp-50 px-4 py-4 text-center text-3xl font-extrabold tracking-[0.5em] text-camp-900 focus:border-camp-500 focus:outline-none focus:ring-4 focus:ring-camp-200"
          />

          <label
            className="mt-4 flex items-center gap-2 text-sm font-bold text-camp-800"
            htmlFor="mozo-dispositivo"
          >
            <Smartphone size={16} /> Nombre de este celular (opcional)
          </label>
          <input
            id="mozo-dispositivo"
            type="text"
            maxLength={60}
            value={dispositivo}
            onChange={(e) => setDispositivo(e.target.value)}
            placeholder="Ej.: Celu de Ana"
            className="mt-1 w-full rounded-2xl border-2 border-gray-200 px-4 py-3 text-base focus:border-camp-500 focus:outline-none focus:ring-4 focus:ring-camp-200"
          />

          <button
            type="submit"
            disabled={enviando}
            className="mt-6 w-full rounded-2xl bg-gradient-to-r from-camp-700 to-camp-500 py-4 text-lg font-extrabold text-white shadow-lg active:scale-[0.99] disabled:opacity-60"
          >
            {enviando ? 'Ingresando...' : 'Ingresar'}
          </button>
        </form>

        <p className="mt-5 text-center text-xs font-semibold text-white/80">
          Driza Camp · Restaurante
        </p>
      </div>
    </div>
  );
}
